export const treeMapOptions = {
  legend: {
    show: false,
  },
  chart: {
    type: 'treemap',
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '14px',
    },
    formatter: function (val, op) {
      return val + op.value + '%';
    },
    offsetY: -5,
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    treemap: {
      enableShades: false,
      reverseNegativeShade: false,
      useFillColorAsStroke: false,
      colorScale: {
        ranges: [
          {
            from: -999999,
            to: -10,
            color: '#460d24',
          },
          {
            from: -10,
            to: -5,
            color: '#7f1a42',
          },
          {
            from: -5,
            to: -2,
            color: '#bb235f',
          },
          {
            from: -2,
            to: 0,
            color: '#E32A73',
          },
          {
            from: 0.0001,
            to: 2,
            color: '#4EFFC8',
          },
          {
            from: 2,
            to: 5,
            color: '#3dc49a',
          },
          {
            from: 5,
            to: 10,
            color: '#2c9171',
          },
          {
            from: 10,
            to: 999999,
            color: '#217057',
          },
        ],
      },
    },
  },
};
